import { call, put, takeLatest, cancelled } from "redux-saga/effects"
import axios from "axios"
import {
  GET_MEDITIONS_WATCHER,
  MEDITIONS_ACTIONS_WATCHER,
  OFFICIALIZE_MEDITIONS_WATCHER,
} from "./constants"

import {
  getMeditionsAvailableActionsFailed,
  getMeditionsAvailableActionsSuccess,
  getMeditionsSuccess,
  getMeditionsFailed,
  officializeFailed,
  officializeSuccess,
} from "./actions"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage"

function getMeditionsApi(params) {
  const url = `companies/${LOCAL_COMPANY_ID()}/measure`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params,
  })
}

function getMeditionAvailableActionsApi(params) {
  const url = `reports/measure/${params.payload.measure_id}/available-actions`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: {
      id_division: params.payload.id_division,
    },
  })
}

export function* getMeditionsSaga(params = {}) {
  const cancelSource = axios.CancelToken.source()
  try {
    const meditionsApi = yield call(getMeditionsApi, {
      "all-data": 0,
      id_segment: params.payload.id_segment,
    })
    const result = {
      meditions: meditionsApi.data.data.measure.filter(
        (x) => x.id_measure_status >= 3
      ),
      ambassador_count: meditionsApi.data.data.ambassador_count,
      allMeditions: meditionsApi.data.data.measure,
    }

    result.isEmptyMeditions = result.meditions.length === 0

    if (params.payload.measure === undefined && result.meditions.length > 0) {
      params.payload.history.push(
        `/reports/measure/${result.meditions[0].id_measure}`
      )
    }
    yield put(getMeditionsSuccess(result))
  } catch (e) {
    // Primero el fallo: sin esto loadingMeditions queda en true para siempre
    yield put(getMeditionsFailed())
    // returnMessage lanza TypeError cuando la respuesta no trae data.data (500, error de red)
    try {
      returnMessage(e, true)
    } catch (messageError) {
      console.error(messageError)
    }
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* officializeSaga(action) {
  try {
    const meditionsApi = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `measure/${action.payload}/officialize`,
    })

    message.success("Se ha oficializado la medición correctamente.", 5)
    yield put(officializeSuccess({}))
  } catch (e) {
    message.error("Hubo un error al oficializar la medición.", 5)
    yield put(officializeFailed())
  }
}

export function* getMeditionAvailableActionsSaga(params = {}) {
  const cancelSource = axios.CancelToken.source()
  try {
    const restApi = yield call(getMeditionAvailableActionsApi, params)

    yield put(getMeditionsAvailableActionsSuccess(restApi.data.data))
  } catch (e) {
    // returnMessage(e, true)
    yield put(getMeditionsAvailableActionsFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Individual exports for testing
export default function* reportsPageSaga() {
  yield takeLatest(GET_MEDITIONS_WATCHER, getMeditionsSaga)
  yield takeLatest(OFFICIALIZE_MEDITIONS_WATCHER, officializeSaga)
  yield takeLatest(MEDITIONS_ACTIONS_WATCHER, getMeditionAvailableActionsSaga)
  // See example in containers/HomePage/saga.js
}
